import React, { useEffect, useMemo, useRef, useState } from 'react';
import TableLayout from '../../molecules/TableLayout';
import Table from '../../molecules/Table';
import Field from '../Field';
import Form from '../../molecules/Form/Form';
import iconMenu from '../../../assets/icon-menu-dots-vertical.svg';
import { IoAdd, IoCloseOutline, IoMegaphoneOutline, IoPauseOutline, IoTrashOutline, IoCheckboxOutline } from 'react-icons/io5';
import dummyImg from '../../../assets/avatar-2.svg';
import { IoIosArrowDown } from 'react-icons/io';
import { useForm } from '../../molecules/Form';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import linkedinService from '../../../services/linkedinService';
import { useNavigate } from 'react-router-dom';
import Toast from '../../molecules/Toast';
import CenterModal from '../../molecules/Modal/CenterModal';
import { StyledLeadsTasks } from './LeadsDetails.styles';
import useDebounce from '../../../hooks/useDebounce';
import usePersistedSearchQuery from '../../../hooks/usePersistedSearchQuery';
import useDummyData from '../../../hooks/useDummyData';
import ModalContainer from '../../molecules/ModalContainer';
import campaignService from '../../../services/campaignService';
import DeleteLead from './DeleteLead.jsx';
import AddToModalContent from './AddToModalContent.jsx';
import { dummyLeadsData } from '../../Constant';
import LeadsEmptyScreen from '../EmptyScreen/LeadsEmptyScreen.jsx';
import ImportLeadsModal from './ImportLeadsModal';
import Loaders from '../Loaders/index.jsx';
import Filters from './Filters.jsx';
import { getAvatarSrc, handleAvatarError } from '../../../helpers/common.js';

const LeadsDetail = ({ mockData, isStorybook, selectionMode, onLeadsSelected, selectedLeadIds }) => {
  const navigate = useNavigate();
  const [form] = useForm();
  const [showDropdown, setShowDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const campaignDropdownRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { fetch, refetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
  }));
  const [searchQuery, setSearchQuery] = usePersistedSearchQuery({
    page: 1,
    itemsPerPage: 10,
    searchText: '',
    getAll: false,
    startDate: '',
    endDate: '',
    status: [],
    contactedStatus: 'ALL',
    source: [],
    campaigns: [],
    tagsFilter: [],
    listsFilter: [],
    dateCreatedFilter: '',
    jobTitle: '',
    companyName: '',
    companyNames: [],
    language: '',
    languages: [],
    locations: [],
    location: '',
    industries: [],
    industry: '',
    headlines: [],
    headline: '',
    emailExists: 'ALL',
    linkedinProfileExists: 'ALL',
    openToWork: 'ALL',
    isHiring: 'ALL',
  });

  const isEmptyFilters =
    !searchQuery?.status?.length &&
    !searchQuery?.source?.length &&
    !searchQuery?.campaigns?.length &&
    !searchQuery?.tagsFilter?.length &&
    !searchQuery?.listsFilter?.length &&
    !searchQuery?.dateCreatedFilter &&
    !searchQuery?.jobTitle &&
    !searchQuery?.searchText &&
    !(Array.isArray(searchQuery?.companyNames) ? searchQuery.companyNames.length : searchQuery?.companyName) &&
    !(Array.isArray(searchQuery?.languages) ? searchQuery.languages.length : searchQuery?.language) &&
    !(Array.isArray(searchQuery?.locations) ? searchQuery.locations.length : searchQuery?.location) &&
    !(Array.isArray(searchQuery?.industries) ? searchQuery.industries.length : searchQuery?.industry) &&
    !(Array.isArray(searchQuery?.headlines) ? searchQuery.headlines.length : searchQuery?.headline) &&
    (!searchQuery?.emailExists || searchQuery?.emailExists === 'ALL') &&
    (!searchQuery?.linkedinProfileExists || searchQuery?.linkedinProfileExists === 'ALL') &&
    (!searchQuery?.openToWork || searchQuery?.openToWork === 'ALL') &&
    (!searchQuery?.isHiring || searchQuery?.isHiring === 'ALL');

  const [tags, setTags] = useState([]);
  const [addToListModal, setAddToListModal] = useState({ open: false, leadId: null });
  const [addToCampaignModal, setAddToCampaignModal] = useState({ open: false, leadId: null });
  const [addToListLoading, setAddToListLoading] = useState(false);
  const [addToCampaignLoading, setAddToCampaignLoading] = useState(false);
  const [selectedList, setSelectedList] = useState(null);
  const [selectedCampaignForLead, setSelectedCampaignForLead] = useState(null);
  const [listDropdownOpen, setListDropdownOpen] = useState(false);
  const [campaignDropdownOpen, setCampaignDropdownOpen] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [lists, setLists] = useState([]);
  const [searchInputValue, setSearchInputValue] = useState('');
  const debouncedSearchValue = useDebounce(searchInputValue);
  const [openLeadsModal, setOpenLeadsModal] = useState(false);


  const [selectedLeads, setSelectedLeads] = useState(() => {
    if (selectionMode && selectedLeadIds) {
      return Object.keys(selectedLeadIds).map(Number);
    }
    return [];
  });
  const [totalSelectedCount, setTotalSelectedCount] = useState(0); // Track total from API when Select All is used
  const [isSelectAllMode, setIsSelectAllMode] = useState(false); // Track if user is in "select all" mode
  const [showBulkDropdown, setShowBulkDropdown] = useState(false);
  const bulkDropdownRef = useRef(null);
  const [previewData, setPreviewData] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [failedAvatarSources, setFailedAvatarSources] = useState(() => new Set());
  // Use reusable hook for dummy data logic
  const { showDummyData } = useDummyData({
    isStorybook,
    mockData,
  });
  const [selectAllLoading, setSelectAllLoading] = useState(false);
  const prevFilterDepsRef = useRef(null);

  const { leads_loading, leads_data } = linkedinService?.GetAlluserLeads(searchQuery, fetch);

  // Override with dummy data if needed
  const finalLeadsData = showDummyData
    ? { leads_loading: false, leads_data: { data: { items: mockData || dummyLeadsData, totalItems: (mockData || dummyLeadsData)?.length || 0 } } }
    : { leads_loading, leads_data };
  const hasItems = !!finalLeadsData.leads_data?.data?.items?.length;
  const leadsLoading = !!finalLeadsData.leads_loading;


  useEffect(() => {
    const handleClickOutside = e => {
      if (e.target.closest('[role="dialog"]') || e.target.closest('.modal-container')) {
        return;
      }
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(null);
      }
      if (bulkDropdownRef.current && !bulkDropdownRef.current.contains(e.target)) {
        setShowBulkDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    setShowDropdown(prevId => (prevId === id ? null : id));
  };


  const handleSelectAll = async () => {
    const totalItems = leads_data?.data?.totalItems || 0;


    if (selectedLeads.length === totalItems && totalItems > 0) {
      setSelectedLeads([]);
      setTotalSelectedCount(0);
      setIsSelectAllMode(false);
      return;
    }


    if (selectAllLoading) return;

    setSelectAllLoading(true);
    try {
      const response = await linkedinService.getUserLeads({
        ...searchQuery,
        getAll: true,
      });

      if (response?.data?.ids && Array.isArray(response.data.ids)) {
        const allLeadIds = response.data.ids;
        setSelectedLeads(allLeadIds);
        // Use totalItems from response to track actual selected count
        setTotalSelectedCount(response.data.totalItems || allLeadIds.length);
        setIsSelectAllMode(true);
      } else {
        Toast({ type: 'warning', message: 'No leads found to select' });
      }
    } catch (error) {
      console.error('Error selecting all leads:', error);
      Toast({
        type: 'error',
        message: error.message || 'Failed to select all leads. Please try again.'
      });
    } finally {
      setSelectAllLoading(false);
    }
  };


  const handleSelectLead = (leadId, checked) => {
    // Reset totalSelectedCount and exit select all mode since user is manually selecting/deselecting
    setTotalSelectedCount(0);
    setIsSelectAllMode(false);
    if (checked) {
      setSelectedLeads(prev => [...prev, leadId]);
    } else {
      setSelectedLeads(prev => prev.filter(id => id !== leadId));
    }
  };


  const isAllSelected = useMemo(() => {
    const currentVisibleIds = finalLeadsData.leads_data?.data?.items?.map(item => item.id) || [];
    if (currentVisibleIds.length === 0) return false;

    const totalItems = finalLeadsData.leads_data?.data?.totalItems || 0;
    if (isSelectAllMode) return true;
    const allVisibleSelected = currentVisibleIds.every(id => selectedLeads.includes(id));
    const allItemsSelected = selectedLeads.length === totalItems && totalItems > 0;

    return allVisibleSelected && allItemsSelected;
  }, [selectedLeads, finalLeadsData, isSelectAllMode]);

  const isIndeterminate = useMemo(() => {
    return selectedLeads.length > 0 && !isAllSelected;
  }, [selectedLeads, isAllSelected]);

  useEffect(() => {
    // Skip all API calls when showing dummy data
    if (!showDummyData) {
      fetchTags();
      fetchAllCampaigns();
      fetchAllLists();
    }
  }, [showDummyData]);

  // Update searchQuery when debounced search value changes
  useEffect(() => {
    setSearchQuery(prev => {
      if (prev.searchText === debouncedSearchValue) return prev;
      return {
        ...prev,
        searchText: debouncedSearchValue,
        page: 1,
      };
    });
  }, [debouncedSearchValue]);

  useEffect(() => {
    const currentDeps = JSON.stringify([
      searchQuery.status,
      searchQuery.contactedStatus,
      searchQuery.source,
      searchQuery.campaigns,
      searchQuery.tagsFilter,
      searchQuery.listsFilter,
      searchQuery.dateCreatedFilter,
      searchQuery.jobTitle,
      searchQuery.searchText,
      searchQuery.companyName,
      searchQuery.language,
      searchQuery.locations,
      searchQuery.location,
      searchQuery.industry,
      searchQuery.headline,
      searchQuery.emailExists,
      searchQuery.linkedinProfileExists,
      searchQuery.openToWork,
      searchQuery.isHiring,
    ]);

    if (prevFilterDepsRef.current === null || prevFilterDepsRef.current === currentDeps) {
      prevFilterDepsRef.current = currentDeps;
      return;
    }
    prevFilterDepsRef.current = currentDeps;

    if (isSelectAllMode) {

      const autoSelectAll = async () => {
        try {
          const response = await linkedinService.getUserLeads({
            ...searchQuery,
            getAll: true,
          });

          if (response?.data?.ids && Array.isArray(response.data.ids)) {
            const allLeadIds = response.data.ids;
            setSelectedLeads(allLeadIds);
            setTotalSelectedCount(response.data.totalItems || allLeadIds.length);
          }
        } catch (error) {
          console.error('Error auto-selecting leads:', error);
          setSelectedLeads([]);
          setTotalSelectedCount(0);
          setIsSelectAllMode(false);
        }
      };

      autoSelectAll();
    } else {
      setSelectedLeads([]);
      setTotalSelectedCount(0);
    }
  }, [
    searchQuery.status,
    searchQuery.contactedStatus,
    searchQuery.source,
    searchQuery.campaigns,
    searchQuery.tagsFilter,
    searchQuery.listsFilter,
    searchQuery.dateCreatedFilter,
    searchQuery.jobTitle,
    searchQuery.searchText,
    searchQuery.companyName,
    searchQuery.language,
    searchQuery.locations,
    searchQuery.location,
    searchQuery.industry,
    searchQuery.headline,
    searchQuery.emailExists,
    searchQuery.linkedinProfileExists,
    searchQuery.openToWork,
    searchQuery.isHiring,
  ]);


  const visibleSelectedCount = useMemo(() => {

    if (totalSelectedCount > 0) {
      return totalSelectedCount;
    }

    return selectedLeads.length;
  }, [selectedLeads, totalSelectedCount]);

  const fetchTags = async () => {
    try {
      const res = await linkedinService.getTags();
      if (res?.success && res?.data) {
        const formattedTags = res.data.map(tag => ({
          label: tag?.name,
          value: tag?.id,
        }));
        setTags(formattedTags);
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to fetch tags' });
    }
  };

  const fetchAllCampaigns = async () => {
    try {
      const res = await linkedinService.getAllCampaigns();
      if (res?.success && res?.data) {
        const formattedCampaigns = res.data.map(campaign => ({
          label: campaign?.name,
          value: campaign?.id,
          status: campaign?.status,
        }));
        // const filteredCampaigns = formattedCampaigns.filter(
        //   campaign => campaign.status === 'draft' || campaign.status === 'running',
        // );
        setCampaigns(formattedCampaigns);
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to fetch campaigns' });
    }
  };

  const fetchAllLists = async () => {
    try {
      const res = await linkedinService.getAllLists();
      if (res?.success && res?.data) {
        const formattedLists = res.data.map(list => ({
          label: list?.name,
          value: list?.id,
        }));
        setLists(formattedLists);
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to fetch lists' });
    }
  };

  const handleAddToList = leadId => {
    setShowDropdown(null);
    setAddToListModal({ open: true, leadId });
  };

  const handleAddToCampaign = leadId => {
    setShowDropdown(null);
    setAddToCampaignModal({ open: true, leadId });
    setPreviewData(null);
    setSelectedCampaignForLead(null);
  };

  const handleDelete = async (leadId) => {
    setShowDropdown(null);
    const leadIds = Array.isArray(leadId) ? leadId : [leadId];

    if (!window.confirm(`Are you sure you want to delete ${leadIds.length} lead(s)?`)) return;

    try {
      await Promise.all(leadIds.map(id => linkedinService.deleteLead(id)));
      Toast({ type: 'success', message: `${leadIds.length} lead(s) deleted successfully` });
      setSelectedLeads([]);
      setTotalSelectedCount(0);
      setRefreshTrigger(prev => prev + 1);
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to delete lead(s)' });
    }
  };

  const handleListSelection = async listId => {
    setSelectedList(listId);
    setPreviewData(null);

    if (!listId) return;

    const leadIds = Array.isArray(addToListModal.leadId) ? addToListModal.leadId : [addToListModal.leadId];

    setPreviewLoading(true);
    try {
      const response = await linkedinService.getSublistUserLeadsPreview({
        sublistId: listId,
        leadId: leadIds,
      });
      setPreviewData(response?.data || null);
    } catch (error) {
      Toast({ type: 'error', message: error?.message || 'Failed to load preview' });
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleAddLeadToList = async () => {
    if (!selectedList) {
      Toast({ type: 'error', message: 'Please select a list' });
      return;
    }

    setAddToListLoading(true);
    try {
      const leadIds = Array.isArray(addToListModal.leadId) ? addToListModal.leadId : [addToListModal.leadId];

      const res = await linkedinService.addLeadstoSublist({ userLeadId: leadIds, listId: selectedList });

      const leadCount = previewData?.uniqueLeads || leadIds.length;
      const successMessage =
        leadCount > 0
          ? `${leadCount} ${leadCount === 1 ? 'lead' : 'leads'} added to ${res?.data?.sublistName}`
          : 'Leads added to list successfully';

      Toast({ type: 'success', message: successMessage });
      setAddToListModal({ open: false, leadId: null });
      setSelectedList(null);
      setListDropdownOpen(false);
      setSelectedLeads([]);
      setTotalSelectedCount(0);
      setIsSelectAllMode(false);
      setPreviewData(null);
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to add lead to list' });
    } finally {
      setAddToListLoading(false);
    }
  };

  const handleCampaignSelection = async campaignId => {
    setSelectedCampaignForLead(campaignId);
    setPreviewData(null);

    if (!campaignId) return;

    const leadIds = Array.isArray(addToCampaignModal.leadId) ? addToCampaignModal.leadId : [addToCampaignModal.leadId];

    setPreviewLoading(true);
    try {
      const res = await campaignService.getUserLeadsPreview({
        campaignId: campaignId,
        leadId: leadIds,
      });
      if (res?.success && res?.data) {
        setPreviewData(res.data);
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to fetch preview' });
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleAddLeadToCampaign = async () => {
    if (!selectedCampaignForLead) {
      Toast({ type: 'error', message: 'Please select a campaign' });
      return;
    }

    setAddToCampaignLoading(true);
    try {
      const leadIds = Array.isArray(addToCampaignModal.leadId) ? addToCampaignModal.leadId : [addToCampaignModal.leadId];

      const res = await campaignService.addUserLeadToCampaign({
        leadId: leadIds,
        campaignId: selectedCampaignForLead,
      });

      const addedCount = previewData?.uniqueLeads || res?.data?.addedLeads || leadIds.length;
      const successMessage =
        addedCount > 0
          ? `${addedCount} ${addedCount === 1 ? 'lead' : 'leads'} added to ${res?.data?.campaignName}`
          : 'Leads added to campaign successfully';

      Toast({ type: 'success', message: successMessage });
      setAddToCampaignModal({ open: false, leadId: null });
      setSelectedCampaignForLead(null);
      setCampaignDropdownOpen(false);
      setSelectedLeads([]);
      setTotalSelectedCount(0);
      setIsSelectAllMode(false);
      setPreviewData(null);
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to add lead to campaign' });
    } finally {
      setAddToCampaignLoading(false);
    }
  };

  // Bulk Actions Handlers
  const handleBulkAddToList = () => {
    setShowBulkDropdown(false);
    // Use all selected leads (selectedLeads contains all IDs from Select All API call)
    handleAddToList(selectedLeads);
  };

  const handleBulkAddToCampaign = () => {
    setShowBulkDropdown(false);
    // Use all selected leads (selectedLeads contains all IDs from Select All API call)
    handleAddToCampaign(selectedLeads);
  };

  const handleBulkDelete = () => {
    setShowBulkDropdown(false);
    // Use all selected leads (selectedLeads contains all IDs from Select All API call)
    handleDelete(selectedLeads);
  };

  const handleUnselectAll = () => {
    setSelectedLeads([]);
    setTotalSelectedCount(0);
    setIsSelectAllMode(false);
    setShowBulkDropdown(false);
  };

  const handleConfirmSelection = () => {
    if (!onLeadsSelected) return;
    const allItems = finalLeadsData.leads_data?.data?.items || [];
    const leadsMap = {};
    selectedLeads.forEach(id => {
      const lead = allItems.find(item => item.id === id);
      if (lead) {
        leadsMap[id] = lead;
      } else {
        // Keep previously selected leads that aren't on the current page
        if (selectedLeadIds && selectedLeadIds[id]) {
          leadsMap[id] = selectedLeadIds[id];
        } else {
          leadsMap[id] = { id };
        }
      }
    });
    onLeadsSelected(leadsMap);
  };

  const handleSelectAllLeads = async () => {
    if (selectAllLoading) return;

    setShowBulkDropdown(false);
    setSelectAllLoading(true);


    try {
      const response = await linkedinService.getUserLeads({
        ...searchQuery,
        getAll: true,
      });

      if (response?.data?.ids && Array.isArray(response.data.ids)) {
        const allLeadIds = response.data.ids;
        setSelectedLeads(allLeadIds);
        // Use totalItems from response to track actual selected count
        setTotalSelectedCount(response.data.totalItems || allLeadIds.length);
        setIsSelectAllMode(true);
      } else {
        Toast({ type: 'warning', message: 'No leads found to select' });
      }
    } catch (error) {
      console.error('Error selecting all leads:', error);
      Toast({
        type: 'error',
        message: error.message || 'Failed to select all leads. Please try again.'
      });
    } finally {
      setSelectAllLoading(false);
    }
  };

  const handleSelectPageLeads = () => {
    const currentPageLeadIds = finalLeadsData.leads_data?.data?.items?.map(item => item.id) || [];

    if (!currentPageLeadIds.length) {
      Toast({ type: 'warning', message: 'No leads found on this page' });
      return;
    }

    setSelectedLeads(prev => [...new Set([...prev, ...currentPageLeadIds])]);
    setTotalSelectedCount(0);
    setIsSelectAllMode(false);
    setShowBulkDropdown(false);
  };



  const ActionBtn = ({ data }) => (
    <ul className="action-list">
      <li className={`action-item ${showDropdown === data.id ? 'active' : ''}`}>
        <button className="btn" type="button" onClick={e => toggleDropdown(e, data.id)}>
          <img className="menu" src={iconMenu} width="6" alt="menu" />
        </button>

        {showDropdown === data.id && (
          <div className="dropdown-menu">
            <ul className="dropdown-list">
              <li className="dropdown-item">
                <button
                  type="button"
                  className="item-btn"
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleAddToList(data.id);
                  }}>
                  <IoAdd size={18} />
                  Add to List
                </button>
              </li>
              <li className="dropdown-item">
                <button
                  type="button"
                  className="item-btn"
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleAddToCampaign(data.id);
                  }}>
                  <IoAdd size={18} />
                  Add to Campaign
                </button>
              </li>
              <li className="dropdown-item">
                {/* <button
                  type="button"
                  className="item-btn"
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleDelete(data.id);
                  }}>
                  Delete
                </button> */}

                <ModalContainer
                  title="Delete List"
                  width={650}
                  isCloseAble={false}
                  btnComponent={({ onClick }) => (
                    <button
                      type="button"
                      className="item-btn"
                      onClick={e => {
                        e.stopPropagation();
                        onClick();
                      }}>
                      <IoTrashOutline size={18} />
                      Delete
                    </button>
                  )}
                  content={({ onClose }) => (
                    <DeleteLead
                      onClose={() => {
                        onClose();
                        setShowDropdown(null);
                      }}
                      leadId={data?.id}
                      onSuccess={() => {
                        refetch();
                      }}
                    />
                  )}
                />
              </li>
            </ul>
          </div>
        )}
      </li>
    </ul>
  );

  const NameHolder = ({ data }) => (
    <div className="lead-td-col" key={`lead-${data?.id}`} onClick={e => e.stopPropagation()}>
      <Field
        type="checkbox"
        noMargin
        name={data?.id}
        value={selectedLeads.includes(data?.id)}
        onChange={({ target: { value } }) => handleSelectLead(data?.id, value)}
        label={
          <div className="flex-content" onClick={() => !selectionMode && navigate(`/lead-preview/${data?.id}`)}>
            <div className="avatar-wrap">
              {leadsLoading ? "loading..." :
                <img
                  src={getAvatarSrc(data?.profile_photo, failedAvatarSources, dummyImg)}
                  alt={data?.name || 'Avatar'}
                  className="avatar"
                  onError={() => handleAvatarError(data?.profile_photo, setFailedAvatarSources)}
                />
              }
            </div>
            <div className="text-wrap" onClick={() => !selectionMode && navigate(`/lead-preview/${data?.id}`)}>
              <span className="campaign-name">
                {' '}
                {`${data?.first_name || ''} ${data?.last_name || ''}` || '-'}
              </span>
            </div>
          </div>
        }
      />
    </div>
  )

  const lockedField = (value, status, placeholder) => {
    if (value) return value;
    if (status === 'AWAITING_LINKEDIN') {
      return (
        <span
          title="Connect LinkedIn account to see"
          style={{ filter: 'blur(4px)', userSelect: 'none', cursor: 'help', color: '#6B7280' }}>
          {placeholder}
        </span>
      );
    }
    if (status === 'ENRICHING') {
      return <span style={{ color: '#075985', fontSize: 12 }}>Enriching…</span>;
    }
    return '-';
  };

  const { product_rows, totalCount } = useMemo(() => {
    let items = [];
    if (showDummyData) {
      items = mockData || dummyLeadsData || [];
    } else {
      items = finalLeadsData?.leads_data?.data?.items || [];
    }

    const cells = items.map(data => {
      const row = [
        NameHolder({ data }),
        lockedField(data.company_name, data.status, 'Company Name'),
        lockedField(data.title, data.status, 'Senior Position'),
        <span className="tag-text" style={{ color: '#0DA06A' }}>
          {data.tags && data.tags.length > 0 ? data.tags.join(', ') : '-'}
        </span>,
        data.email || '-',
      ];
      if (!selectionMode) {
        row.push(<ActionBtn key={`action-${data.id}`} data={data} />);
      }
      return { id: data.id, cells: row, isDropdownOpen: showDropdown === data.id };
    });

    return {
      product_rows: cells,
      totalCount: showDummyData
        ? (mockData || dummyLeadsData)?.length || 0
        : finalLeadsData.leads_data?.data?.totalItems,
    };
  }, [finalLeadsData, showDropdown, refreshTrigger, showDummyData, mockData, selectedLeads, selectionMode, failedAvatarSources]);

  const columnNames = [
    <div className="th-label-box">
      <div className="checkbox-wrapper">
        <Field
          type="checkbox"
          name="select_all"
          noMargin
          label={<></>}
          value={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={handleSelectAll}
        />
        <div className="bulk-dropdown-wrapper" ref={bulkDropdownRef}>
          <button
            type="button"
            className="bulk-dropdown-trigger"
            onClick={(e) => {
              e.stopPropagation();
              setShowBulkDropdown(!showBulkDropdown);
            }}>
            {visibleSelectedCount > 0
              ? `${visibleSelectedCount} Selected`
              : ''}
            <IoIosArrowDown size={16} />
          </button>
          {showBulkDropdown && (
            <div className="bulk-dropdown-menu">
              <ul className="bulk-dropdown-list">
                <li>
                  <button
                    type="button"
                    className="bulk-dropdown-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectPageLeads();
                    }}>
                    <IoCheckboxOutline size={18} />
                    Select Page
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className="bulk-dropdown-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectAllLeads();
                    }}
                    disabled={selectAllLoading}
                    style={{ opacity: selectAllLoading ? 0.6 : 1, cursor: selectAllLoading ? 'not-allowed' : 'pointer' }}>
                    <IoCheckboxOutline size={18} />
                    {selectAllLoading ? 'Selecting...' : 'Select All'}
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className="bulk-dropdown-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUnselectAll();
                    }}>
                    <IoCloseOutline size={18} />
                    Unselect All
                  </button>
                </li>
                {!selectionMode && (
                  <>
                    <li>
                      <button
                        type="button"
                        className="bulk-dropdown-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleBulkAddToList();
                        }}
                        disabled={visibleSelectedCount === 0}
                        style={{ opacity: visibleSelectedCount === 0 ? 0.5 : 1, cursor: visibleSelectedCount === 0 ? 'not-allowed' : 'pointer' }}>
                        <IoAdd size={18} />
                        Add to List
                      </button>
                    </li>
                    <li>
                      <button
                        type="button"
                        className="bulk-dropdown-item"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleBulkAddToCampaign();
                        }}
                        disabled={visibleSelectedCount === 0}
                        style={{ opacity: visibleSelectedCount === 0 ? 0.5 : 1, cursor: visibleSelectedCount === 0 ? 'not-allowed' : 'pointer' }}>
                        <IoAdd size={18} />
                        Add to Campaign
                      </button>
                    </li>
                  </>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
      <span className="column-label">Name</span>
    </div>,
    'Company',
    'Position',
    'Tag',
    'Email',
    ...(!selectionMode ? ['Action'] : []),
  ];
  return (
    <StyledLeadsTasks className={selectionMode ? 'selection-mode' : ''}>
      {selectionMode ? (
        <>
          <div className="selection-content">
            <Form form={form} className="filter-column">
              <div className="head">
                <Form.Item
                  colorBg inputSm noMargin label="" type="search" rounded
                  name="search" placeholder="Search Lead"
                  value={searchInputValue}
                  onChange={e => setSearchInputValue(e?.target?.value || '')}>
                  <Field />
                </Form.Item>
              </div>
              <div className="core-filer">
                <span className="text">Core Filters</span>
              </div>
              <div className="filter-holder">
                <Filters
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  campaigns={campaigns}
                  tags={tags}
                  lists={lists}
                  filters={[
                    'Lead Status',
                    'Contacted Status',
                    'Lead Source',
                    'Campaign',
                    'Tags',
                    'List',
                    'Date Created',
                    'Company Name',
                    'Job Title',
                    'Email',
                    'LinkedIn Profile',
                    'Language',
                    'Location',
                    'Industry',
                    'Headline',
                    'Open to Work',
                    'Is Hiring',
                  ]}
                />
              </div>
            </Form>
            {
              // finalLeadsData.leads_loading && !hasItems ? (
              //   <Loaders viewLoader />
              // ) :
              !leadsLoading && !hasItems ? (
                <LeadsEmptyScreen onButtonClick={() => setOpenLeadsModal(true)} />
              ) : (
                <div className="table-area">
                  <TableLayout
                    noStyle
                    onChangeFilters={filters => {
                      setSearchQuery(_ => ({ ..._, ...filters }));
                    }}
                    currentPage={searchQuery.page}
                    pageSize={searchQuery.itemsPerPage}
                    innerHeight="100%"
                    totalCount={totalCount}>
                    <Table
                      rowsData={product_rows}
                      columnNames={columnNames}
                      noPadding
                      noPaddingBottom
                      profilePicture
                      loading={leads_loading}
                      noNewStyle
                      clickable={false}
                    />
                  </TableLayout>
                </div>
              )}
          </div>
          <div className="selection-footer" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 16px',
            borderTop: '1px solid #f4f4f5',
            background: '#fafafa',
          }}>
            <span style={{ fontSize: 14, color: '#71717a' }}>
              {selectedLeads.length} lead{selectedLeads.length !== 1 ? 's' : ''} selected
            </span>
            <button
              type="button"
              onClick={handleConfirmSelection}
              disabled={selectedLeads.length === 0}
              style={{
                padding: '8px 20px',
                borderRadius: 50,
                border: 'none',
                background: selectedLeads.length === 0 ? '#e4e4e7' : '#2783EC',
                color: selectedLeads.length === 0 ? '#a1a1aa' : '#fff',
                fontSize: 14,
                fontWeight: 600,
                cursor: selectedLeads.length === 0 ? 'not-allowed' : 'pointer',
              }}>
              Confirm Selection
            </button>
          </div>
        </>
      ) : (
        <>
          <Form form={form} className="filter-column">
            <div className="head">
              <Form.Item
                colorBg
                inputSm
                noMargin
                label=""
                type="search"
                rounded
                name="search"
                placeholder="Search Lead"
                value={searchInputValue}
                onChange={e => {
                  const value = e?.target?.value || '';
                  setSearchInputValue(value);
                }}>
                <Field />
              </Form.Item>
            </div>
            <div className="core-filer">
              <span className="text">Core Filters</span>
            </div>
            <div className="filter-holder">
              <Filters
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                campaigns={campaigns}
                tags={tags}
                lists={lists}
                filters={[
                  'Lead Status',
                  'Contacted Status',
                  'Lead Source',
                  'Campaign',
                  'Tags',
                  'List',
                  'Date Created',
                  'Company Name',
                  'Job Title',
                  'Email',
                  'LinkedIn Profile',
                  'Language',
                  'Location',
                  'Industry',
                  'Headline',
                  'Open to Work',
                  'Is Hiring',
                ]}
              />
            </div>
          </Form>
          {
            !leadsLoading && !hasItems && isEmptyFilters ? (
              <LeadsEmptyScreen onButtonClick={() => setOpenLeadsModal(true)} />
            ) : (
              <div className="table-area leads-module">
                <TableLayout
                  noStyle
                  onChangeFilters={filters => {
                    setSearchQuery(_ => ({
                      ..._,
                      // searchText: filters,
                      ...filters,
                    }));
                  }}
                  currentPage={searchQuery.page}
                  pageSize={searchQuery.itemsPerPage}
                  totalCount={totalCount}
                >
                  <div className="leads-table-scroll">
                    <Table
                      rowsData={product_rows}
                      columnNames={columnNames}
                      noPadding
                      loading={leads_loading}
                      noPaddingBottom
                      clickable={true}
                      profilePicture
                      noNewStyle
                      onRowClick={row => {
                        if (!selectionMode) navigate(`/lead-preview/${row?.id}`);
                      }}
                    />
                  </div>
                </TableLayout>
              </div>
            )}
        </>
      )}

      <ImportLeadsModal
        open={openLeadsModal}
        setOpen={setOpenLeadsModal}
        onSuccess={() => {
          setRefreshTrigger(prev => prev + 1);
        }}
      />

      <CenterModal
        title="Add to List"
        open={addToListModal.open}
        setOpen={isOpen => {
          setAddToListModal({ open: isOpen, leadId: null });
          setSelectedList(null);
          setListDropdownOpen(false);
          setPreviewData(null);
        }}
        width="600">
        <AddToModalContent
          label="Select List"
          placeholder="Select a list"
          options={lists}
          selectedValue={selectedList}
          setSelectedValue={handleListSelection}
          loading={addToListLoading}
          onCancel={() => {
            setAddToListModal({ open: false, leadId: null });
            setSelectedList(null);
            setListDropdownOpen(false);
            setPreviewData(null);
          }}
          onSubmit={handleAddLeadToList}
          showPreview={Array.isArray(addToListModal.leadId) && addToListModal.leadId.length > 1}
          previewLoading={previewLoading}
          previewData={previewData}
        />
      </CenterModal>

      <CenterModal
        title="Add to Campaign"
        open={addToCampaignModal.open}
        setOpen={isOpen => {
          setAddToCampaignModal({ open: isOpen, leadId: null });
          setSelectedCampaignForLead(null);
          setCampaignDropdownOpen(false);
          setPreviewData(null);
        }}
        width="600">
        <AddToModalContent
          label="Select Campaign"
          placeholder="Select a campaign"
          options={campaigns}
          selectedValue={selectedCampaignForLead}
          setSelectedValue={handleCampaignSelection}
          loading={addToCampaignLoading}
          onCancel={() => {
            setAddToCampaignModal({ open: false, leadId: null });
            setSelectedCampaignForLead(null);
            setCampaignDropdownOpen(false);
            setPreviewData(null);
          }}
          onSubmit={handleAddLeadToCampaign}
          showPreview={Array.isArray(addToCampaignModal.leadId) && addToCampaignModal.leadId.length > 1}
          previewLoading={previewLoading}
          previewData={previewData}
        />
      </CenterModal>
    </StyledLeadsTasks >
  );
};

export default LeadsDetail;
